var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-return-button",on:{"click":_vm.goBack}},[_c('div',{staticClass:"back-button"},[_c('back-icon',{staticClass:"back-icon"})],1),_c('span',[_vm._v(_vm._s(_vm.$t('widgets.return')))])])}
var staticRenderFns = []

export { render, staticRenderFns }